import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const Login = () =>
  import(/* webpackChunkName: 'login' */ "@/view/login/index.vue");
const PromotionHome = () =>
  import(/* webpackChunkName: 'login' */ "@/view/promotion/home.vue");
const Custom = () =>
  import(/* webpackChunkName: 'login' */ "@/view/promotion/custom.vue");
const Industry = () =>
  import(/* webpackChunkName: 'login' */ "@/view/promotion/industry.vue");
const Query = () =>
  import(/* webpackChunkName: 'login' */ "@/view/promotion/query.vue");
const Agree = () =>
  import(/* webpackChunkName: 'login' */ "@/view/agree/index.vue");
const Secret = () =>
  import(/* webpackChunkName: 'login' */ "@/view/agree/secret.vue");
const Page404 = () =>
  import(/* webpackChunkName: 'login' */ "@/view/error/404.vue");

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/home",
    name: "home",
    component: PromotionHome,
  },
  {
    path: "/custom",
    name: "custom",
    component: Custom,
  },
  {
    path: "/industry",
    name: "industry",
    component: Industry,
  },
  {
    path: "/query",
    name: "query",
    component: Query,
  },
  {
    path: "/agree",
    name: "agree",
    component: Agree,
  },
  {
    path: "/secret",
    name: "secret",
    component: Secret,
  },
  {
    path: '*',
    component: Page404,

  }
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
